const datePickerOptions = {
  enableTime: true,
  dateFormat: "DD/MM/YYYY HH:mm",
  placeholder: "dd/mm/yyyy hh:mm",
};

export default {
  order: [
    "absenceReason",
    "sentOnOpen",
    "sentOnUpdate",
    "sentOnClose",
    "activeFrom",
    "activeTo",
    "*",
  ],
  id: { "ui:widget": "hidden" },
  absenceReason: {
    id: {
      "ui:title": "Absence Reason",
    },
  },
  textMessage: {
    "ui:widget": "textarea",
    "ui:options": {
      rows: 4,
    },
  },
  sentOnOpen: {
    "ui:widget": "toggle",
  },
  sentOnUpdate: {
    "ui:widget": "toggle",
  },
  sentOnClose: {
    "ui:widget": "toggle",
  },
  activeFrom: {
    "ui:widget": "date-picker",
    "ui:options": datePickerOptions,
  },
  activeTo: {
    "ui:widget": "date-picker",
    "ui:options": datePickerOptions,
  },
};
